import * as React from "react";
import OverlaySpinner from "../../../Loaders/OverlaySpinner";
import TextInputField from "../../Base/Fields/TextInputField";
import Modal from "../../Base/Modals/Modal";

import { cloneDeep } from "lodash";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { setActiveFormInstance } from "../../../../store/base";
import {
  constants,
  create,
  update,
  useBrfManualCapitalAddonForm,
} from "../../../../store/brfManualCapitalAddon";
import { DatePicker } from "../../Base/Fields";

export default function IndexTableModalForm({
  method,
  id,
  closeFunction,
  instance,
  brfCompanyId,
}) {
  const dispatch = useDispatch();
  const storeName = constants.STORE_NAME;
  const { push } = useHistory();
  const formLoaded = useBrfManualCapitalAddonForm(method, id);

  const [actionLoading, setActionLoading] = React.useState(false);

  React.useEffect(() => {
    if (instance) {
      dispatch(
        setActiveFormInstance({
          storeName,
          data: instance,
        })
      );
    }
  }, []);

  const preProcess = (data) => {
    const dataClone = cloneDeep(data);

    if (method === "PATCH") return dataClone;

    dataClone.brf_company = { id: brfCompanyId };

    return dataClone;
  };

  const onSubmit = () => {
    setActionLoading(true);

    if (method === "POST") {
      dispatch(
        create({
          preProcess,
          successCallback: (_, returned) => {
            setActionLoading(false);
            closeFunction();
          },
          errorCallback: () => {
            setActionLoading(false);
          },
        })
      );
    } else {
      dispatch(
        update({
          id,
          successCallback: (_, returned) => {
            setActionLoading(false);
            closeFunction();
          },
          errorCallback: () => {
            setActionLoading(false);
          },
        })
      );
    }
  };

  const loading = !formLoaded || actionLoading;
  return (
    <Modal
      closeFunction={closeFunction}
      title={
        method === "POST"
          ? "Lägg till kapitaltillskott"
          : "Uppdatera kapitaltillskott"
      }
      acceptTitle={"Spara"}
      onAccept={onSubmit}
    >
      {loading && <OverlaySpinner />}

      <div className="mb-6 grid grid-cols-2 gap-6">
        <TextInputField
          title="Värde"
          fieldKey="value"
          {...{ method, storeName }}
        />
        <DatePicker
          title="Datum"
          fillWidth
          extraStyle={{ width: "100%" }}
          fieldKey="as_of_date"
          {...{ method, storeName }}
        />
      </div>
    </Modal>
  );
}
